/*
--------------------------------------------------------------------------------
Module for displaying iframes which need send eshop message
--------------------------------------------------------------------------------

<![CDATA[

*/

(function ($) {
    'use strict';

    ori.messenger.addModule("iframeDisplay", {
        // default options & settings --------------------------------------------------

        DataSourceUrl: "", //System/UI/EShop/LoadPartialPage/?ds={DataSourceGUID}
        StatusCheckerUrl: "/System/UI/EShop/GetPageStatus/",
        AsyncId: "",
        Timeout: 1000, //in millisecond
        Target: "", //class of div where preloader will be displayed
        LoadSpinnerOnInit: true,
        SendOrderMessageUrl: "/System/UI/EShop/SendOrderEshopMessage",
        CheckoutPageUrl: "/shopping/checkout",
        SendEshopMessageUrl: "/System/UI/EShop/SendEshopMessage/",
        SuccessUrl: "",
        ErrorUrl: "",
        ErrorMessage: "Communication with eshop failed.",
        CheckoutPageErrorMessage: "",
        CheckoutPageCriticalThresholdMessage: "",
        CheckoutPageEshopLoadEnabled: false,
        // initialization --------------------------------------------------------------
        /**
        * Initialization of default options.
        */
        init: function (options) {
            // set options if provided
            if (options) {
                for (var p in options) {
                    if(!options.hasOwnProperty(p)){
                        continue;
                    }

                    this[p] = options[p];
                }
            }

            if (ori.messenger.iframeDisplay.LoadSpinnerOnInit) {
                ori.spinner.applyTo(jQuery(this.Target));
            }
        },

        StatusChecker: function (loadComplete) {
            var self = ori.messenger.iframeDisplay;
            setTimeout(function () {
                self.info("Checking status of async task at " + self.StatusCheckerUrl);
                jQuery.post(self.StatusCheckerUrl + self.AsyncId, function (data) {
                    if (data.IsFaulted) {
                        self.warning("EShopCommunication failed");
                        if (self.LoadSpinnerOnInit) {
                            ori.spinner.removeFrom(self.Target);
                        }
                        jQuery(self.Target).removeClass("ui-spinner empty-page");

                        showErrorMsg("<p>" + self.ErrorMessage + "</p>");

                        if (self.ErrorUrl) {
                            ori.redirect.setWindowLocation(self.ErrorUrl);
                        }

                        return;
                    }
                
                    if (data.IsCompleted) {
                        self.info("Requesting resource: " + self.DataSourceUrl);
                        jQuery(self.Target).load(self.DataSourceUrl, loadComplete);
                        jQuery(self.Target).removeClass("ui-spinner empty-page");
                        return;
                    }
                    self.StatusChecker();
                });
            }, self.Timeout);
        },

        SendOrderMessageAndCheckStatus: function () {
            var self = ori.messenger.iframeDisplay;
            ori.spinner.applyTo(jQuery(this.Target));
            jQuery(".ui-spinner").show();
            jQuery.post(self.SendOrderMessageUrl, function (data) {
                if (data.Result == "sent") {
                    if (data.AsyncId == "-1") {
                        ori.redirect.setWindowLocation(self.CheckoutPageUrl);
                    }
                    self.AsyncId = data.AsyncId;
                    self.Timeout = data.Timeout;

                    self.OrderMessageStatusChecker();
                }
            });

        },

        OrderMessageStatusChecker: function () {
            var self = ori.messenger.iframeDisplay;
            setTimeout(function () {
                self.info("Checking status of async task at " + self.StatusCheckerUrl);
                jQuery.post(self.StatusCheckerUrl + self.AsyncId, function (data) {
                    if (data.IsFaulted) {
                        self.warning("EShopCommunication failed");
                        if (self.LoadSpinnerOnInit) {
                            ori.spinner.removeFrom(self.Target);
                        }
                        jQuery(self.Target).removeClass("ui-spinner empty-page");

                        showErrorMsg("<p>" + self.ErrorMessage + "</p>");

                        if (self.ErrorUrl) {
                            ori.redirect.setWindowLocation(self.ErrorUrl);
                        }
                        return;
                    }

                    if (self.CheckoutPageEshopLoadEnabled && ori.popup) {
                        if (data.Result.Code) {
                            var popupMessageTemplate = '<div class="ui-message v-icon-round-exclam has-icon"><p class="msg">{0}</p></div>';
                            var msg = null;
                            if (data.Result.Code === -1) {
                                msg = kendo.format(popupMessageTemplate, self.CheckoutPageErrorMessage);
                            } else if (data.Result.Code === -2) {
                                msg = kendo.format(popupMessageTemplate, self.CheckoutPageCriticalThresholdMessage);
                            }

                            if (msg) {
                                showErrorMsg(msg);
                                if (self.ErrorUrl) {
                                    ori.redirect.setWindowLocation(self.ErrorUrl);
                                }
                                return;
                            }

                        }
                    }
                    if (data.IsCompleted) {
                        self.info("Message successfully processed, redirect");
                        ori.redirect.setWindowLocation(self.CheckoutPageUrl);
                        return;
                    }
                    self.OrderMessageStatusChecker();
                });
            }, self.Timeout);
        },

        SendEshopMessageAndCheckStatus: function (datasourceId) {
            var self = ori.messenger.iframeDisplay;
        
            var messageUrl = self.SendEshopMessageUrl + datasourceId;
            jQuery.post(messageUrl, function (data) {
                if (data.Result == "sent") {
                    if (data.AsyncId == "-1") {
                        ori.redirect.setWindowLocation(window.location.href); // TODO what to do? (sent with error?)
                    }
                    self.AsyncId = data.AsyncId;
                    self.Timeout = data.Timeout;

                    self.EshopMessageStatusChecker();
                }
            });

        },

        EshopMessageStatusChecker: function () {
            var self = ori.messenger.iframeDisplay;
            setTimeout(function () {
                self.info("Checking status of async task at " + self.StatusCheckerUrl);
                jQuery.post(self.StatusCheckerUrl + self.AsyncId, function (data) {
                    if (data.IsFaulted) {
                        self.warning("EShopCommunication failed");
                        if (self.LoadSpinnerOnInit) {
                            ori.spinner.removeFrom(self.Target);
                        }
                        jQuery(self.Target).removeClass("ui-spinner empty-page");
                    
                        showErrorMsg("<p>" + self.ErrorMessage + "</p>");

                        if (self.ErrorUrl) {
                            ori.redirect.setWindowLocation(self.ErrorUrl);
                            }
                        return;
                    }
                    if (data.IsCompleted) {
                        self.info("Message successfully processed, redirect");
                        ori.redirect.setWindowLocation(self.SuccessUrl);
                        return;
                    }
                
                    self.OrderMessageStatusChecker();
                });
            }, self.Timeout);
        }
    });

    function showErrorMsg(msg){
        var ERROR_MSG_WINDOW = 'error-msg-window';

        $('body').append($('<div />').attr('id', ERROR_MSG_WINDOW).html(msg));
        $('#' + ERROR_MSG_WINDOW).kendoWindow({
            visible: false,
            showOverlay: true,
            title: false,
            resizable: false,
            draggable: false,
            deactivate: function () {
                this.destroy();
            }
        }).data('kendoWindow').open();
    }
})(jQuery);

/* ]]> */